/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Type_NameInputs */

const vi_tea_type_name = /** @type {(inputs: Tea_Type_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên loại chè`)
};

/**

* @param {Tea_Type_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_type_name = /** @type {((inputs?: Tea_Type_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Type_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_type_name(inputs)
});